import { Tool } from '../types';
import NumberConverter from '../tools/NumberConverter';
import TimezoneConverter from '../tools/TimezoneConverter';
import CurrencyConverter from '../tools/CurrencyConverter';
import JsonFormatter from '../tools/JsonFormatter';
import TimestampConverter from '../tools/TimestampConverter';
import Base64Converter from '../tools/Base64Converter';
import UrlConverter from '../tools/UrlConverter';
import RegexTester from '../tools/RegexTester';
import UuidGenerator from '../tools/UuidGenerator';
import ColorConverter from '../tools/ColorConverter';
import WordCounter from '../tools/WordCounter';
import ChineseConverter from '../tools/ChineseConverter';
import DateCalculator from '../tools/DateCalculator';
import UnitConverter from '../tools/UnitConverter';
import QrcodeGenerator from '../tools/QrcodeGenerator';
import PasswordGenerator from '../tools/PasswordGenerator';
import MortgageCalculator from '../tools/MortgageCalculator';
import TextDiff from '../tools/TextDiff';
import JsonYamlConverter from '../tools/JsonYamlConverter';
import IdCardTool from '../tools/IdCardTool';
import TextDedup from '../tools/TextDedup';

export const tools: Tool[] = [
    {
        id: 'number-converter',
        title: '大小写转换',
        description: '数字中文大写互转 + 英文大小写/命名风格转换',
        icon: '🔤',
        color: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        keywords: ['数字', '大写', '金额', '英文', '大小写', '驼峰', '下划线', 'camelCase', 'snake_case', 'kebab'],
        category: 'life',
        component: NumberConverter,
    },
    {
        id: 'timezone-converter',
        title: '时区转换',
        description: '查看全球时间并在时区之间换算',
        icon: '🌍',
        color: 'linear-gradient(135deg, #ec4899 0%, #f43f5e 100%)',
        keywords: ['时区', '时间', 'timezone', 'utc', 'world clock'],
        category: 'life',
        component: TimezoneConverter,
    },
    {
        id: 'currency-converter',
        title: '汇率转换',
        description: '主流货币之间的金额快速换算',
        icon: '💱',
        color: 'linear-gradient(135deg, #0ea5e9 0%, #22d3ee 100%)',
        keywords: ['汇率', '货币', '外汇', 'currency', 'exchange'],
        category: 'life',
        component: CurrencyConverter,
    },
    {
        id: 'date-calculator',
        title: '日期计算器',
        description: '日期间隔、日期推算、年龄计算',
        icon: '📅',
        color: 'linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%)',
        keywords: ['日期', '年龄', '天数', '计算', 'date', 'calendar'],
        category: 'life',
        component: DateCalculator,
    },
    {
        id: 'unit-converter',
        title: '单位换算',
        description: '长度、重量、温度、面积、速度换算',
        icon: '📏',
        color: 'linear-gradient(135deg, #10b981 0%, #14b8a6 100%)',
        keywords: ['单位', '换算', '长度', '重量', '温度', '面积', '速度', 'convert'],
        category: 'life',
        component: UnitConverter,
    },
    {
        id: 'json-formatter',
        title: 'JSON 格式化',
        description: '格式化、压缩并校验 JSON 数据',
        icon: '📝',
        color: 'linear-gradient(135deg, #10b981 0%, #34d399 100%)',
        keywords: ['json', '格式化', '压缩', 'format', 'beautify'],
        category: 'dev',
        component: JsonFormatter,
    },
    {
        id: 'timestamp-converter',
        title: '时间戳转换',
        description: 'Unix 时间戳与日期时间双向转换',
        icon: '⏰',
        color: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
        keywords: ['时间戳', 'timestamp', 'unix', '日期', 'date'],
        category: 'dev',
        component: TimestampConverter,
    },
    {
        id: 'base64-converter',
        title: 'Base64 编解码',
        description: '文本与 Base64 字符串互转',
        icon: '🔐',
        color: 'linear-gradient(135deg, #8b5cf6 0%, #d946ef 100%)',
        keywords: ['base64', '编码', '解码', 'encode', 'decode'],
        category: 'dev',
        component: Base64Converter,
    },
    {
        id: 'url-converter',
        title: 'URL 编解码',
        description: 'URL 参数的编码与解码',
        icon: '🔗',
        color: 'linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)',
        keywords: ['url', '编码', '解码', 'encode', 'decode', 'encodeURIComponent'],
        category: 'dev',
        component: UrlConverter,
    },
    {
        id: 'regex-tester',
        title: '正则测试器',
        description: '测试正则表达式，高亮显示匹配结果',
        icon: '🔍',
        color: 'linear-gradient(135deg, #f43f5e 0%, #ec4899 100%)',
        keywords: ['regex', '正则', 'regular expression', '匹配', 'match'],
        category: 'dev',
        component: RegexTester,
    },
    {
        id: 'uuid-generator',
        title: 'UUID 生成器',
        description: '一键生成 UUID，支持批量生成',
        icon: '🆔',
        color: 'linear-gradient(135deg, #6366f1 0%, #a855f7 100%)',
        keywords: ['uuid', 'guid', '随机', 'id', '生成'],
        category: 'dev',
        component: UuidGenerator,
    },
    {
        id: 'color-converter',
        title: '颜色转换',
        description: 'HEX / RGB / HSL 颜色格式互转',
        icon: '🎨',
        color: 'linear-gradient(135deg, #f97316 0%, #ef4444 100%)',
        keywords: ['颜色', 'color', 'hex', 'rgb', 'hsl', '转换'],
        category: 'dev',
        component: ColorConverter,
    },
    {
        id: 'word-counter',
        title: '字数统计',
        description: '中英文字符、单词、行数实时统计',
        icon: '📊',
        color: 'linear-gradient(135deg, #14b8a6 0%, #06b6d4 100%)',
        keywords: ['字数', '统计', '字符', '计数', 'word count'],
        category: 'dev',
        component: WordCounter,
    },
    {
        id: 'chinese-converter',
        title: '简繁转换',
        description: '简体中文与繁体中文互转',
        icon: '🀄',
        color: 'linear-gradient(135deg, #ef4444 0%, #f97316 100%)',
        keywords: ['简体', '繁体', '中文', '转换', '简繁'],
        category: 'life',
        component: ChineseConverter,
    },
    {
        id: 'qrcode-generator',
        title: '二维码生成',
        description: '输入文本或 URL，生成二维码图片',
        icon: '📱',
        color: 'linear-gradient(135deg, #22d3ee 0%, #6366f1 100%)',
        keywords: ['二维码', 'qr code', '生成', '条形码'],
        category: 'life',
        component: QrcodeGenerator,
    },
    {
        id: 'password-generator',
        title: '密码生成器',
        description: '按规则生成随机安全密码',
        icon: '🔑',
        color: 'linear-gradient(135deg, #a855f7 0%, #6366f1 100%)',
        keywords: ['密码', '随机', '安全', 'password', '生成'],
        category: 'life',
        component: PasswordGenerator,
    },
    {
        id: 'mortgage-calculator',
        title: '房贷计算器',
        description: '等额本息/等额本金房贷还款计算',
        icon: '🏠',
        color: 'linear-gradient(135deg, #14b8a6 0%, #0ea5e9 100%)',
        keywords: ['房贷', '贷款', '月供', '利息', 'mortgage', '还款'],
        category: 'life',
        component: MortgageCalculator,
    },
    {
        id: 'text-diff',
        title: '文本差异对比',
        description: '并排对比两段文本差异，支持8种语法高亮',
        icon: '📋',
        color: 'linear-gradient(135deg, #6366f1 0%, #ec4899 100%)',
        keywords: ['diff', '对比', '差异', 'compare', '文本比较', 'merge'],
        category: 'dev',
        component: TextDiff,
    },
    {
        id: 'text-dedup',
        title: '文本去重排序',
        description: '多行文本按行去重并自动排序，去除首尾空白',
        icon: '✨',
        color: 'linear-gradient(135deg, #6366f1 0%, #ec4899 100%)',
        keywords: ['去重', '排序', '文本', '去重排序', 'dedup', 'unique', 'trim'],
        category: 'dev',
        component: TextDedup,
    },
    {
        id: 'json-yaml-converter',
        title: 'JSON ↔ YAML 互转',
        description: 'JSON 与 YAML 格式实时互相转换',
        icon: '🔄',
        color: 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)',
        keywords: ['json', 'yaml', '转换', 'convert', '序列化', '反序列化'],
        category: 'dev',
        component: JsonYamlConverter,
    },
    {
        id: 'id-card-validator',
        title: '身份证号工具',
        description: '校验身份证号格式，批量生成有效身份证号',
        icon: '🪪',
        color: 'linear-gradient(135deg, #10b981 0%, #0ea5e9 100%)',
        keywords: ['身份证', 'ID card', '校验', '验证', '实名', '生成', '批量'],
        category: 'life',
        component: IdCardTool,
    },
];
